// autolayout/logos_text - S48.2b / S48.2c.
// resolverLogosFromText(text, logosConfig)
//   - text: string (puede ser multilinea, ej. items_resumen de un bundle).
//   - logosConfig: mapa { MARCA: 'archivo.svg' }. La MARCA puede ser una
//     palabra simple ('MAZDA') o compuesta ('LAND ROVER', 'ALFA ROMEO').
//
// A diferencia de resolverLogos (que espera marca exacta o lista delimitada
// por separadores), esta funcion ESCANEA el texto buscando ocurrencias de
// cada key del logosConfig como subcadena con limite de palabra. Esto
// permite detectar marcas dentro de texto libre tipo:
//   'MAZDA 3\nMITSUBISHI LANCER\nDODGE CALIBER\nSUZUKI VITARA'
// o con marcas compuestas:
//   'LAND ROVER DEFENDER\nALFA ROMEO 159'
// y devolver [LAND ROVER, ALFA ROMEO] (S48.2c soporte explicito).
//
// Reglas (S48.2c):
//   - Match case-insensitive (uppercase del texto y de la key).
//   - Limites de palabra: caracter previo y posterior fuera de [A-Z0-9].
//     Espacios internos en la key (ej. 'LAND ROVER') NO afectan los
//     limites; el match es la cadena completa.
//   - Preferir match mas LARGO cuando dos keys overlappan en posicion:
//     si keys = ['ALFA','ALFA ROMEO'] y texto = 'ALFA ROMEO 159',
//     gana 'ALFA ROMEO' y se descarta 'ALFA' en esa posicion.
//   - Dedup por key en orden de PRIMERA aparicion.
//   - Si la key tiene entrada en logosConfig (valor truthy) -> img.
//   - Si la key existe en logosConfig pero el valor es vacio -> tag.
//   - Texto vacio o sin matches -> [].

function _isWordChar(ch) {
  if (!ch) return false;
  const c = ch.charCodeAt(0);
  if (c >= 48 && c <= 57) return true;
  if (c >= 65 && c <= 90) return true;
  return false;
}

function _findAllOccurrences(haystackUpper, needle) {
  const out = [];
  if (!needle || needle.length === 0) return out;
  let from = 0;
  while (from <= haystackUpper.length - needle.length) {
    const idx = haystackUpper.indexOf(needle, from);
    if (idx < 0) break;
    const before = idx > 0 ? haystackUpper.charAt(idx - 1) : '';
    const after = (idx + needle.length) < haystackUpper.length
      ? haystackUpper.charAt(idx + needle.length) : '';
    if (!_isWordChar(before) && !_isWordChar(after)) {
      out.push(idx);
    }
    from = idx + needle.length;
  }
  return out;
}

function _isEclipsed(hit, others) {
  // hit es eclipsado si hay un OTHER mas largo que cubre completamente
  // su rango. Si dos hits cubren exactamente el mismo rango, no se
  // eclipsan entre si (la dedup por key se encarga).
  for (let i = 0; i < others.length; i += 1) {
    const o = others[i];
    if (o === hit) continue;
    if (o.start <= hit.start && o.end >= hit.end) {
      if (o.end - o.start > hit.end - hit.start) return true;
    }
  }
  return false;
}

export function resolverLogosFromText(text, logosConfig) {
  if (text == null || text === '') return [];
  const upper = String(text).toUpperCase();
  const cfg = logosConfig || {};
  const keys = Object.keys(cfg);
  // Recolectar todos los hits (key, start, end). Multiples ocurrencias
  // de una misma key generan hits separados — el dedup posterior se
  // encarga de quedarse con la primera.
  const allHits = [];
  for (let i = 0; i < keys.length; i += 1) {
    const k = keys[i];
    if (!k) continue;
    const upK = k.toUpperCase();
    const positions = _findAllOccurrences(upper, upK);
    for (let j = 0; j < positions.length; j += 1) {
      const start = positions[j];
      allHits.push({ key: k, start: start, end: start + upK.length });
    }
  }
  // Filtrar hits eclipsados por matches mas largos en el mismo rango.
  const survivors = [];
  for (let i = 0; i < allHits.length; i += 1) {
    if (!_isEclipsed(allHits[i], allHits)) survivors.push(allHits[i]);
  }
  // Ordenar por posicion ascendente y deduplicar por key (orden de
  // primera aparicion).
  survivors.sort((a, b) => a.start - b.start);
  const out = [];
  const seen = {};
  for (let i = 0; i < survivors.length; i += 1) {
    const h = survivors[i];
    if (seen[h.key]) continue;
    seen[h.key] = true;
    const src = cfg[h.key];
    if (src) {
      out.push({ type: 'img', label: h.key, src: src });
    } else {
      out.push({ type: 'tag', label: h.key });
    }
  }
  return out;
}
